// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import "./App.css"
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AIPolicyPage from './pages/AIPolicyPage';
import AIPolicyAppendix1 from './pages/AIPolicyAppendix1';
import AIPolicyAppendix2 from './pages/AIPolicyAppendix2';
import AIPolicyAppendix3 from './pages/AIPolicyAppendix3';
import AIPolicyAppendix4 from './pages/AIPolicyAppendix4';
import AIPolicyAppendix5 from './pages/AIPolicyAppendix5';
import Kvkk from './pages/Kvkk';
import Rehber from './pages/Rehber';
import AnalyticsTracker from "./AnalyticsTracker";

function App() {
  return (
    <Router>
      <AnalyticsTracker /> {/* Sayfa değişikliklerini takip eden bileşen */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gizlilik-ve-cerez-politikasi" element={<PrivacyPolicy />} />
        <Route path="/uyelik-sozlesmesi-ve-site-kullanim-kosullari" element={<TermsOfService />} />
        <Route path="/ai-policy" element={<AIPolicyPage />} />
        <Route path="/ai-policy/uygulama-plani" element={<AIPolicyAppendix1 />} />
        <Route path="/ai-policy/maarif-modeli-uyumu" element={<AIPolicyAppendix2 />} />
        <Route path="/ai-policy/kullanici-taahhutnamesi" element={<AIPolicyAppendix3 />} />
        <Route path="/ai-policy/kredi-sistemi" element={<AIPolicyAppendix4 />} />
        <Route path="/ai-policy/referans-dokumanlar" element={<AIPolicyAppendix5 />} />
        <Route path="/kvkk" element={<Kvkk />} />
        <Route path="/rehber" element={<Rehber />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
